import { render, staticRenderFns } from "./roster_logs.vue?vue&type=template&id=1b8adbdc&scoped=true&"
import script from "./roster_logs.vue?vue&type=script&lang=js&"
export * from "./roster_logs.vue?vue&type=script&lang=js&"
import style0 from "./roster_logs.vue?vue&type=style&index=0&id=1b8adbdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8adbdc",
  null
  
)

export default component.exports